import Head from 'next/head';
import { NextSeo } from 'next-seo';
import CommunityPageLayout from '@layout/CommunityPageLayout';
import Community from '@educator/Container/Community/Community';
import {
  fetchCommunityDetails,
  fetchCommunityShareCard
} from '@actions/educator';
import { useSelector } from 'react-redux';
import {
  getCommunityShareCard,
  getCommunityDetails
} from '@selectors/educator';
import setupInitialProps from '@utils/setupInitialProps';
import escape from '@utils/escapeHTML';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const EducatorCommunities = ({ id }) => {
  const communityData = useSelector(getCommunityDetails);
  const shareInfo = useSelector(getCommunityShareCard);
  const title = 'Unacademy - lets crack it!';
  const description = `Join ${communityData.author?.first_name} ${communityData.author?.last_name}’s community and join learners across India to crack ${communityData.goal?.name} exams`;
  const canonicalURL = `https://unacademy.com/community/${id}`;

  return (
    <>
      <NextSeo
        title={title}
        openGraph={{
          title,
          description,
          url: canonicalURL,
          images: [
            {
              url:
                shareInfo[communityData.author?.username] || shareInfo.default
            }
          ]
        }}
        twitter={{
          cardType: 'summary_large_image'
        }}
      />
      <Head>
        <title>{title}</title>
      </Head>
      <Community />
    </>
  );
};

EducatorCommunities.Layout = CommunityPageLayout;

EducatorCommunities.pageInfo = {
  name: 'Educator Communities',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default EducatorCommunities;

EducatorCommunities.getInitialProps = setupInitialProps(
  async ({ store, query }) => {
    const { id } = query;
    const promises = [];
    promises.push(store.dispatch(fetchCommunityDetails(id)));
    promises.push(store.dispatch(fetchCommunityShareCard()));
    await Promise.all(promises);
    return { id: escape(id) };
  },
  EducatorCommunities.pageInfo
);
EducatorCommunities.Wrapper = PageReduxProvider;
